import type { Passenger } from '@massilia/prisma-generated'

import { useQuery } from '@tanstack/react-query'

import { apiClient } from '../../../lib/client.js'
import { estimateKeys } from './keys.js'

export const useGetClientPassengersQuery = (clientId: null | string) =>
  useQuery({
    enabled: !!clientId,
    queryFn: async () => {
      if (!clientId) return []
      const response = await apiClient.client.get<Passenger[]>(`/client/${clientId}/passengers`)
      return response.data
    },
    queryKey: estimateKeys.clientPassengers(clientId ?? ''),
    staleTime: 5 * 60 * 1000, // 5 minutes - prevent refetching when switching between clients
  })
